import { render, staticRenderFns } from "./BindGiftCard.vue?vue&type=template&id=a7b9ce68&scoped=true&"
import script from "./BindGiftCard.vue?vue&type=script&lang=ts&"
export * from "./BindGiftCard.vue?vue&type=script&lang=ts&"
import style0 from "./BindGiftCard.vue?vue&type=style&index=0&id=a7b9ce68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b9ce68",
  null
  
)

export default component.exports